import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { PartsBusinessService } from './../../../business-services/parts.service';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { BrandType } from '../../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { PartsListViewModel, AlternatePartList, AdditionalPartList, ReplacementPartList } from '../../../business-entities/parts-list-view-model';
import { CookieService } from 'ngx-cookie-service';
import { UserDataService } from 'src/app/DataServices/user-data.service';

@Component({
  selector: 'app-add-parts',
  templateUrl: './add-parts.component.html'
})
export class AddPartsComponent implements OnInit {

  addPartsForm: FormGroup;
  costTypeData = [];
  unitPrice:string;
  languageList: any[];
  makeCode: string;
  makeList: BrandType[] = [];
  dropdownSettings = {};
  selectedAdditionalItems:any[]=[];
  selectedAdditionalItemsString:string = '';
  selectedAlternateItems:any[]=[];
  selectedAlternateItemsString:string = '';
  selectedReplacementItems:any[]=[];
  selectedReplacementItemsString:string = '';
  additionalPartsList: PartsListViewModel[] = [];
  alternatePartsList: PartsListViewModel[] = [];
  replacementPartsList: PartsListViewModel[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private partService: PartsBusinessService,
    private globalSetting:GlobalSetting,
    private currentLanguageService: CurrentLanguage,
    private activeModal : NgbActiveModal,
    private brandService: BrandService,
    private cookieservice: CookieService,
    private userService: UserDataService,
  ) { }

  ngOnInit(): void {
    this.languageList = this.currentLanguageService.LanguageList;
    this.addPartsForm = this.formBuilder.group({
      partNumber: ['', [Validators.required]],
      service: new FormArray([]),
      costType: [null],
      unitPrice: [''],
      isActive: [true],
      makeCode: ['', [Validators.required]],
      isFixed:[false]
    });
    this.getLanguage();
    this.GetAllMake();
    this.costTypeData = [{ id: 1, name: "Personnel" }, { id: 2, name: "Material" }, { id: 3, name: "External" }]
    if(this.partService.costType)
      this.partService.isEdit = true;
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'description',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: false,
        maxHeight: 500
      };
  }
  get t() { return this.cpf.service as FormArray; }
  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
        for (let i = this.t.length; i < number; i++) {
            this.t.push(this.formBuilder.group({
                languageId: ['',],
                name: ['', Validators.required],
                description: ['', Validators.required],
            }));
        }
    } else {
        for (let i = this.t.length; i >= number; i--) {
            this.t.removeAt(i);
        }
    }
}
async GetAllMake(): Promise<void> {
  await this.brandService.GetBrandDropdown().then(data => {
    this.makeList = data.responseObject;
    this.getAllParts();
  });
}
async getAllParts() {
  this.spinner.show();
  let model = {
    makeCode: "",
    description:  "",
    no:  "",
    languageCode:this.cookieservice.get('userSelectedLanguage'),
    dealerId: ""
  }
  await this.partService.getParts(model).then(response => {
    this.additionalPartsList=response.filter(s => s.makeCode == this.makeCode);
    this.alternatePartsList=response.filter(s => s.makeCode == this.makeCode);
    this.replacementPartsList=response;
    this.spinner.hide();
  },_error => {
    this.spinner.hide();
  });

}
OnMakeChange(){
  this.selectedAdditionalItems = [];
  this.selectedAlternateItems = [];
  this.selectedReplacementItems = [];
  this.getAllParts();
}
  get cpf() {
    return this.addPartsForm.controls;
  }

  onBlur(event){
    this.unitPrice = event.target.value;
  }

  addParts() {
    this.spinner.show();
    let selectedAdditionalItems = [];
    let selectedAlternateItems = [];
    let selectedReplacementItems = [];
    let additionalError = ''; let alternateError = ''; let replacementError = '';
    this.selectedAdditionalItems.forEach(x =>
      {
        if(this.additionalPartsList.filter(y => y.id == x.id)[0].hasAdditionalItems || this.additionalPartsList.filter(y => y.id == x.id)[0].hasAlternativeItems || this.additionalPartsList.filter(y => y.id == x.id)[0].hasReplacementItems){
          additionalError = this.translate.instant("lblCantAddAdditionalPart");
        }
        else{
          let Obj:AdditionalPartList = {
            additionalPartId : x.id,
            additionalPartNumber: this.additionalPartsList.filter(y => y.id == x.id)[0].partNumber
           };
           selectedAdditionalItems.push(Obj);
        }
      });
    this.selectedAlternateItems.forEach(x =>
        {
          if(this.alternatePartsList.filter(y => y.id == x.id)[0].hasAdditionalItems || this.alternatePartsList.filter(y => y.id == x.id)[0].hasAlternativeItems || this.alternatePartsList.filter(y => y.id == x.id)[0].hasReplacementItems){
            alternateError = this.translate.instant("lblCantAddAlternatePart");
          }
          else{
            let Obj:AlternatePartList = {
              alternatePartId : x.id,
              alternatePartNumber: this.alternatePartsList.filter(y => y.id == x.id)[0].partNumber
             };
             selectedAlternateItems.push(Obj);
          }
    });
    this.selectedReplacementItems.forEach(x =>
          {
            if(this.replacementPartsList.filter(y => y.id == x.id)[0].hasAdditionalItems || this.replacementPartsList.filter(y => y.id == x.id)[0].hasAlternativeItems || this.replacementPartsList.filter(y => y.id == x.id)[0].hasReplacementItems){
              replacementError = this.translate.instant("lblCantAddReplacementPart");
            }
            else{
              let Obj:ReplacementPartList = {
                replacementPartId : x.id,
                replacementPartNumber: this.replacementPartsList.filter(y => y.id == x.id)[0].partNumber,
                makeCode: this.replacementPartsList.filter(y => y.id == x.id)[0].makeCode
               };
               selectedReplacementItems.push(Obj);
            }
    });
    if(additionalError != '') this.toaster.error(additionalError);
    if(alternateError != '') this.toaster.error(alternateError);
    if(replacementError != '') this.toaster.error(replacementError);
    if(additionalError != '' || alternateError != '' || replacementError != ''){
      this.spinner.hide();
      return;
    }
    const viewModel = {
      Lnlnvalue: this.addPartsForm.value.service,
      Id:0,
      partNumber: (this.addPartsForm.get('partNumber').value === '' ? false : this.addPartsForm.get('partNumber').value),
      IsActive: (this.addPartsForm.get('isActive').value === '' ? false : this.addPartsForm.get('isActive').value),
      costType: (this.addPartsForm.get('costType').value === '' ? false : this.addPartsForm.get('costType').value),
      unitPrice: (this.addPartsForm.get('unitPrice').value === '' ? false : this.globalSetting.getFormattedprice(this.addPartsForm.get('unitPrice').value)),
      makeCode: this.makeCode,
      selectedAdditionalItems: selectedAdditionalItems,
      selectedAlternateItems:selectedAlternateItems,
      selectedReplacementItems:selectedReplacementItems,
      isFixed: ((this.addPartsForm.get('isFixed')?.value === '' || this.addPartsForm.get('isFixed')?.value === null) ? false : this.addPartsForm.get('isFixed').value),
      userId:this.userService.currentUserValue.userId
    }
    this.partService.addParts(viewModel).then(res => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        if(res.responseObject.isSuccess && res.responseObject.retValue == '0'){
          this.spinner.hide();
          let errorErr = this.translate.instant("lblPartExist");
          this.toaster.error(errorErr);
        }
        else if(res.responseObject.isSuccess && res.responseObject.retValue != '0'){
          let successMsg = this.translate.instant("lblPartUpdated");
          this.toaster.success(successMsg);
          this.activeModal.close({ success: true
          });
        }
        else{
          let errorErr = this.translate.instant("lblUnknownErrorOccured");
          this.toaster.error(errorErr);
          this.spinner.hide();
        }
      }
    });
    this.spinner.hide();
  }
  OnClose(){
    this.activeModal.dismiss('Cross click')
  }

}
